export default __webpack_public_path__ + "locales/ar-SA/PrivacyPage.json?hash=6157a22f1c39e82b20fab987af877c7b";